import { Client } from '@src/common/services/Client';
import { AxiosResponseConverter } from '@src/documents/AxiosResponseConverter';

export const PublicConditionsSheetsClient = {
  download: async (
    token: string,
  ): Promise<{ blob: Blob; filename: string }> => {
    const response = await Client.get<Blob>('/public/conditionsSheets', {
      params: { token },
      responseType: 'blob',
    });
    const contentDisposition = response.headers['content-disposition'] as
      | string
      | undefined;
    const fileNameRegexp = /filename="(.*)"/;
    const matches = contentDisposition
      ? contentDisposition.match(fileNameRegexp)
      : null;
    const filename = matches ? matches[1] : 'downloaded-file';
    const blob = AxiosResponseConverter.toBlob(response);

    return { blob, filename };
  },
};
